var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{attrs:{"row":_vm.row,"hide-details":_vm.hideDetails},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }